import dayjs from 'dayjs';

import type { Feature, IConfig, IConfigService } from './config.types';

export type { Feature, IInmatePurchaseItem } from './config.types';

const baseConfig: IConfig = {
  // Default template ids
  eventNotification: {
    preaReportTemplateIds: {
      Email: 7,
    },
    textMessageAlertTemplateIds: {
      Email: 8,
      Text: 9,
      Call: 10,
    },
  },
  name: '', // We load this value upon loading a facility
  timezone: 'America/Chicago', // Default to America/Chicago but change when we load the facility
  nodeServer: import.meta.env.VITE_NODE_SERVER ?? '',
  eventRelayServer: import.meta.env.VITE_EVENT_RELAY_SERVER ?? '',
  api: {
    url: import.meta.env.VITE_SITE_API_URL ?? location.origin + '/api-site',
  },
  centralApi: {
    url: import.meta.env.VITE_CENTRAL_API_URL ?? '',
  },
  auth: {
    clientId: 'relcore-site',
    accessTokenUri:
      (import.meta.env.VITE_CENTRAL_API_URL ?? '') + '/auth/token',
    clientSecret: '',
  },
  features: [],
  sip: {
    host: 'window.location.hostname',
    // Username and password are unimportant since session ID header will be used for auth
    user: 'rwis',
    password: '',
    wsServers:
      (location.protocol === 'https:' ? 'wss://' : 'ws://') +
      window.location.hostname +
      '/opensips',
  },
  connectServer: {
    url: null,
  },
  phpDateFormat: 'YYYY-MM-DD HH:mm:ss',
  urlDateFormat: 'YYYYMMDD_HHmmss',
  urlDateRegex: /\d{8}_\d{6}/,
  inmate: {
    itdsEnabled: false, // Enable ITDS features
    housingUnitsEnabled: false,
    pinLength: 6,
    purchaseItems: [
      {
        cost: 3,
        title: 'Headphones',
        transactionDescription: 'Replacement headphones',
      },
    ],
  },
  privateNumber: {
    readOnly: false,
  },
  visitation: {
    timeLimitOptions: [15, 30, 60],
    defaultTimeLimit: 30,
    visitationVisitorOptionalFields: [],
  },
  search: {
    defaultStartDatePeriod: -1,
    outbound: {
      defaultMinDuration: 0,
      defaultMaxDuration: null,
      startDatePeriod: 1,

      // Options: Destination, PhoneCard, Inmate
      criteriaChoices: ['Destination', 'PhoneCard', 'Inmate'],

      // One of the above criteriaChoices options
      defaultCriteriaChoice: 'Destination',

      callTypes: {
        'audio-call': 'Audio',
        'video-call': 'Video',
      },

      defaultCallTypes: ['audio-call', 'video-call'],
    },
    inbound: {
      startDatePeriod: 1,
      source: 'central',
    },
    visitation: {
      startDatePeriod: 1,
      defaultMinDuration: 60,
      visitTypes: {},
    },
    minDate: dayjs().subtract(7, 'years'),
    maxDate: dayjs().endOf('day'),
  },
};

const config: IConfigService = {
  ...baseConfig,
  hasFeature(feature: Feature) {
    return (this.features || []).indexOf(feature) > -1;
  },
  hasOneOfFeatures(features: Feature[]) {
    return features.reduce((prev, cur) => prev || this.hasFeature(cur), false);
  },
};

export default config;
